import { avatars } from "@/assets/avatars";

const testimonialsEn = [
  {
    quote: "Quality Nexus transformed our testing processes. Their experts delivered exceptional results that helped us launch with confidence.",
    name: "Sarah Chen",
    title: "CTO, TechInnovate",
    type: "client",
    avatar: avatars["aya"]
  },
  {
    quote: "The community at Quality Nexus has been instrumental in my growth as a QA engineer. The mentorship and challenges helped me level up my skills.",
    name: "Marcus Johnson",
    title: "Senior QA Engineer",
    type: "community",
    avatar: ""
  },
  {
    quote: "We reduced our bug escape rate by 78% after implementing the test strategy designed by Quality Nexus. Their approach to quality is revolutionary.",
    name: "Jennifer Lee",
    title: "VP of Engineering, DataFlow Systems",
    type: "client",
    avatar: avatars["aya"]
  },
  {
    quote: "The badges and certification system motivated me to expand my testing knowledge. I've gained skills and made connections that accelerated my career.",
    name: "Raj Patel",
    title: "Automation Specialist",
    type: "community",
    avatar: avatars["aya"]
  },
  {
    quote: "Working with Quality Nexus has been a game-changer for our development team. We now catch critical issues early in the cycle.",
    name: "Michael Torres",
    title: "Development Lead, CloudTech",
    type: "client",
    avatar: avatars["aya"]
  },
  {
    quote: "The workshops and training provided by Quality Nexus have significantly improved our team's ability to write testable code.",
    name: "Aisha Rahman",
    title: "QA Manager",
    type: "community",
    avatar: avatars["aya"]
  }
];

export default testimonialsEn;